const playBtns = document.querySelectorAll<HTMLElement>('.video-inline__play');
const autoplayControls = document.querySelectorAll<HTMLElement>('.video-inline__controls');

playBtns.forEach((playBtn) => {
	playBtn.addEventListener('click', () => {
		const media = playBtn.parentElement;
		if (!media) return;

		media.classList.add('component-media--show-video');

		const video = media.querySelector<HTMLElement>('.video-inline');
		if (!video) return;

		video.classList.add('video-inline--is-visible');
		playBtn.style.display = 'none';

		const iframe = video.querySelector<HTMLIFrameElement>('iframe');
		if (iframe) {
			const videoSrc = iframe.getAttribute('data-src');
			if (videoSrc) {
				iframe.src = videoSrc;
				iframe.classList.add('visible');
			}
		}
	});
});

autoplayControls.forEach((autoplayControl) => {
	const iframe = autoplayControl.nextElementSibling as HTMLIFrameElement | null;
	if (!iframe || iframe.tagName.toLowerCase() !== 'iframe') return;

	const player = new window.Vimeo.Player(iframe);

	const autoPlayBtn = autoplayControl.querySelector<HTMLButtonElement>(
		'.video-inline__auto-play-pause'
	);

	autoPlayBtn?.addEventListener('click', async () => {
		const autoPlayIcon = autoPlayBtn.querySelector<HTMLElement>('span[class^=icon]');
		const isPaused = await player.getPaused();
		if (isPaused) {
			await player.play();
			autoPlayIcon?.classList.remove('icon-play');
			autoPlayIcon?.classList.add('icon-pause');
		} else {
			await player.pause();
			autoPlayIcon?.classList.remove('icon-pause');
			autoPlayIcon?.classList.add('icon-play');
		}
	});
});
